import {
    Column
} from 'devextreme-react/data-grid';

import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { useState } from 'react';
import { useGetOutOfStock } from '../api/get-out-of-stock';
import OutOfStockOrdersPopup from './OutOfStockOrdersPopup';

export default function OutOfStockGrid() {

    const outOfStock = useGetOutOfStock();

    const [popupState, setPopupState] = useState<{ visible: boolean, productID?: number }>(
        { visible: false, productID: undefined });

    return (
        <>
            <SyncDataGrid
                stateStorageKey='out-of-stock-grid'
                className={'dx-card wide-card'}
                dataSource={outOfStock.data}
                keyExpr={'outOfStockID'}
                height="68vh"
            >
                <Column
                    dataField={'description'}
                    caption={'Description'}
                    dataType="string"
                />
                <Column
                    dataField={'productLine'}
                    caption={'Product Line'}
                    dataType="string"
                />
                <Column
                    dataField={'sku'}
                    caption={'SKU'}
                    dataType="string"
                />
                <Column
                    dataField={'lastOrderDate'}
                    caption={'Last Order Date'}
                    dataType="date"
                />
                <Column
                    dataField={'estimatedDeliveryDate'}
                    caption={'Estimated Delivery Date'}
                    dataType="date"
                />
                <Column
                    dataField={'orderCount'}
                    caption={'Orders'}
                    dataType="string"
                    cellRender={(row) => {
                        return <a onClick={() => {
                            setPopupState({ visible: true, productID: row.data.productID });
                        }}>
                            {row.data.orderCount}
                        </a>;
                    }}
                />
            </SyncDataGrid>

            <OutOfStockOrdersPopup
                visible={popupState.visible}
                productID={popupState.productID!}
                onHidden={() => setPopupState({ visible: false })} />

            <LoadPagePanel visible={outOfStock.isLoading} />
        </>
    )
} 
